import { StrictMode } from 'react';
import { BrowserRouter } from 'react-router';

import * as ReactDOM from 'react-dom/client';
import { ZfWebComponentsConfig } from '@zafire/react';
import '@zafire/foundations/design-tokens.css';
import '@zafire/foundations/font-faces.css';

import App from './app/app';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <ZfWebComponentsConfig iconBaseUrl={`${window.location.origin}/assets/icons`}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ZfWebComponentsConfig>
  </StrictMode>,
);
